<template>
  <g>
    <g :transform="`scale(${scaleX} ${scaleY})`">
      <g :transform="(flip === true ? `scale(-1 1)`: `scale(1 1)`)">
        <!-- white background -->
        <rect width="45" height="15" :x="x - 5" :y="y -7"
              fill="#fff" />
        <!-- light elements -->
        
        <!-- stroke element -->
        <path :stroke="strokeColor" stroke-width="1" :fill="backgroundColor"
              :d="`M ${(x - 5)} ${y -7 + 1} 
                   L ${(x - 5 + 8)} ${y -7 + 1} 
                   L ${(x - 5 + 8 + 1)} ${y - 5 + 1} 
                   L ${(x - 5 + 10)} ${y -7 + 1} 
                   L ${(x - 5 + 10 + 5)} ${y -7 + 1} 
                   L ${(x - 5 + 10 + 7 + 8)} ${y -7 + 1} 
                   L ${(x - 5 + 10 + 7 + 8 + 1)} ${y -5 + 1} 
                   L ${(x - 5 + 10 + 7 + 10)} ${y -7 + 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 8)} ${y -7 + 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10)} ${y -5 + 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 4)} ${y -5 + 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 4 + 1)} ${y -3 + 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 6)} ${y -5 + 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 6 + 8)} ${y -5 + 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 6 + 8)} ${y +5 - 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 6)} ${y +5 - 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 6)} ${y +5 - 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 4 +1)} ${y +3 - 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10 + 4)} ${y + 5 - 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 10)} ${y +5 - 1} 
                   L ${(x - 5 + 10 + 7 + 10 + 8)} ${y +7 - 1} 
                   L ${(x - 5 + 10 + 7 + 10)} ${y +7 - 1} 
                   L ${(x - 5 + 10 + 7 + 8 + 1)} ${y +5 - 1} 
                   L ${(x - 5 + 10 + 7 + 8)} ${y +7 - 1} 
                   L ${(x - 5 + 10 + 5)} ${y +7 - 1} 
                   L ${(x - 5 + 10)} ${y +7 - 1} 
                   L ${(x - 5 + 8 + 1)} ${y +5 - 1} 
                   L ${(x - 5 + 8)} ${y +7 - 1} 
                   L ${(x - 5)} ${y +7 - 1} 
                   Z`" />
        <rect width="8" height="11" :x="x - 5" :y="y - 5.5"
              :fill="fillColor" />
        <rect width="5" height="11" :x="x - 5 + 10" :y="y -5.5"
              :fill="fillColor" />
        <rect width="8" height="11" :x="x - 5 + 10 + 7" :y="y -5.5"
              :fill="fillColor" />
        <rect width="8" height="11" :x="x - 5 + 10 + 7 + 10" :y="y -5.5"
              :fill="fillColor" />
        <rect width="4" height="6" :x="x - 5 + 10 + 7 + 10 + 10" :y="y -3.5"
              :fill="fillColor" />
        <rect width="8" height="6" :x="x - 5 + 10 + 7 + 10 + 10 + 6" :y="y -3.5"
              :fill="fillColor" />
      </g>
    </g>
  </g>
</template>

<script>
export default {
  name: 'BendProtection',
  data () {
    return {
      fillColors: {
        schwarz: '#232323',
        grün: 'rgb(31, 157, 85)',
        rot: '#d1230c',
        weiß: '#f9f9f9',
        default: '#ababab',
        grau: '#ababab',
        blau: 'rgb(66, 134, 244)'
      },
      strokeColors: {
        schwarz: '#424242',
        grün: '#126335',
        rot: '#7a1d11',
        weiß: '#c1c1c1',
        grau: '#868686',
        default: '#868686',
        blau: 'rgb(30, 54, 94)'
      },
      backgroundColors: {
        schwarz: '#565656',
        grün: '#008739',
        rot: '#af1907',
        weiß: '#f9f9f9',
        default: '#ababab',
        grau: '#bcbcbc',
        blau: 'rgb(51, 104, 191)'
      }
    }
  },
  props: {
    color: {type: String, default: 'default'}, 
    flip: Boolean, 
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    scaleX: {
      type: Number,
      default: 1
    },
    scaleY: {
      type: Number,
      default: 1
    }
  },
  computed: {
    fillColor () {
      return this.color != "" ? this.fillColors[this.color] : "#ababab";
    },
    strokeColor () {
      return this.color != "" ? this.strokeColors[this.color] : "#868686";
    },
    backgroundColor () {
      return this.color != "" ? this.backgroundColors[this.color] : "#ababab";
    }
  }
}
</script>